<div class="box">
    <h3 class="mb-3">Reglas de activación</h3>

    <!-- Operador lógico -->
    <div class="row mb-3" *ngIf="conditions.length > 1">
        <div class="col-4">
            <app-select label="Operador lógico" [list]="logicalOperatorOptions" listDisplay="label"
                [(ngModel)]="uiLogicalOperator" (selectedItem)="logicalOperator = $event?.value; onChange()">
            </app-select>
        </div>
    </div>

    <!-- Tabla -->
    <table class="table">
        <thead>
            <tr>
                <th style="width: 80px"></th>
                <th>Término</th>
                <th style="width: 180px">Operador</th>
                <th style="width: 80px"></th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let condition of conditions; let i = index">
                <!-- Where / or / and -->
                <td class="fw-bold text-uppercase">
                    <span *ngIf="i === 0">Where</span>
                    <span *ngIf="i > 0">{{ logicalOperator }}</span>
                </td>

                <!-- Term -->
                <td>
                    <input type="text" class="form-control" [(ngModel)]="condition.term" (ngModelChange)="onChange()"
                        placeholder="Ingrese término de búsqueda" [required]="true" />
                </td>

                <!-- Operator -->
                <td>
                    <app-select class="compact" [list]="conditionOperatorOptions" listDisplay="label"
                        [(ngModel)]="uiConditionOperators[i]" [required]="true" (selectedItem)="
                    condition.operator = $event?.value;
                    onChange()
                  ">
                    </app-select>
                </td>
                

                <!-- Acciones -->
                <td class="text-end">
                    <div class="dropdown" (click)="$event.stopPropagation()">
                        <button type="button" class="btn btn-link p-0" (click)="toggleMenu(i, $event)">
                            ⋮
                        </button>

                        <div class="dropdown-menu" *ngIf="openMenuIndex === i">
                            <button class="dropdown-item" (click)="duplicateCondition(i); $event.stopPropagation()">
                                Duplicar
                            </button>

                            <button class="dropdown-item text-danger"
                                (click)="removeCondition(i); $event.stopPropagation()">
                                Eliminar
                            </button>
                        </div>
                    </div>
                </td>


            </tr>
        </tbody>
    </table>

    <!-- Acciones inferiores -->
    <div class="d-flex justify-content-between mt-3">
        <button class="button off" (click)="clearConditions()">
            Limpiar reglas
        </button>

        <button class="button" (click)="addCondition()">
            + Agregar condición
        </button>
    </div>
</div>